'use client';

import { useEffect, useMemo } from 'react';
import { useAppContext } from '@/contexts';
import { useGetHousingList } from '@/queris';
import { getFilterObject } from '@/common';
import { parseFilters } from './useFilters';

function parseFiltersFromUrl(listUrl: string) {
  const url = new URL(listUrl, window.location.origin);
  return parseFilters(url.searchParams);
}

export const useNavigationObjectList = (listUrl: string | null) => {
  const { objectList, setObjectList } = useAppContext();

  const shouldFetch = objectList.length === 0 && !!listUrl;

  const searchFilters = useMemo(() => {
    if (!shouldFetch || !listUrl) return undefined;
    const filters = parseFiltersFromUrl(listUrl);
    return getFilterObject(filters);
  }, [listUrl, shouldFetch]);

  const { data, isLoading } = useGetHousingList(searchFilters, {
    enabled: shouldFetch,
  });

  useEffect(() => {
    if (data?.objects) {
      setObjectList(data.objects);
    }
  }, [data, setObjectList]);

  return { isLoading: shouldFetch && isLoading };
};
